<div class="table-solicitacao">
  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    <div style="padding-top: 4px"></div>
  }
  <mat-card appearance="outlined">
    <div class="table-container">
      <table
        #table
        mat-table
        [dataSource]="dataSource()"
        multiTemplateDataRows
        matSort
        matSortStart="desc"
        (matSortChange)="onSortChange($event)"
        class="mat-elevation-z8 responsive-table"
      >
        <!-- Coluna ID -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            # da Solicitação
          </th>
          <td mat-cell *matCellDef="let element; table: table">
            {{ element.id }}
          </td>
        </ng-container>

        <!-- Coluna Cliente -->
        <ng-container matColumnDef="cliente">
          <th mat-header-cell *matHeaderCellDef>Cliente</th>
          <td mat-cell *matCellDef="let element; table: table">
            {{ element["organizationName"] || "-" }}
          </td>
        </ng-container>

        <!-- Coluna Solicitante -->
        <ng-container matColumnDef="createdBy">
          <th mat-header-cell *matHeaderCellDef>Solicitante</th>
          <td mat-cell *matCellDef="let element; table: table">
            {{ element["userName"] || element["createdBy"] || "-" }}
          </td>
        </ng-container>

        <!-- Coluna Data -->
        <ng-container matColumnDef="createdDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header start>
            Data da Solicitação
          </th>
          <td mat-cell *matCellDef="let element; table: table">
            {{ element.createdDate | date }}
          </td>
        </ng-container>

        <!-- Coluna Consistência -->
        <ng-container matColumnDef="consistency">
          <th mat-header-cell *matHeaderCellDef>Consistência</th>
          <td mat-cell *matCellDef="let element; table: table">
            <mat-chip
              [ngClass]="getConsistencyClass(element.isInconsistency)"
              disableRipple
            >
              {{ getConsistencyLabel(element.isInconsistency) }}
            </mat-chip>
          </td>
        </ng-container>

        <!-- Coluna Safra -->
        <ng-container matColumnDef="cropPeriod">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Safra</th>
          <td mat-cell *matCellDef="let element; table: table">
            {{ element.safra }}
          </td>
        </ng-container>

        <!-- Coluna Cultura -->
        <ng-container matColumnDef="cropCulture">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Cultura</th>
          <td mat-cell *matCellDef="let element; table: table">
            {{ element.cultura }}
          </td>
        </ng-container>

        <!-- Coluna Status -->
        <ng-container matColumnDef="status">
          <th
            mat-header-cell
            mat-sort-header="status.description"
            *matHeaderCellDef
          >
            Status da Solicitação
          </th>
          <td mat-cell *matCellDef="let element; table: table">
            <mat-chip
              [ngClass]="getStatusClass(element.status.code!)"
              disableRipple
            >
              {{ element.status.description }}
            </mat-chip>
          </td>
        </ng-container>

        <!-- Coluna Ações -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Relatórios</th>
          <td mat-cell *matCellDef="let element; table: table">
            @for (action of actions(); track action.label) {
              @if (shouldShowAction(action, element)) {
                <button
                  mat-icon-button
                  extended
                  (click)="executeAction(action, element, $event)"
                >
                  <mat-icon>{{ action.icon }}</mat-icon>
                </button>
              }
            }
          </td>
        </ng-container>

        <!-- Coluna Expand -->
        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef aria-label="row actions">
            Resumo
          </th>
          <td mat-cell *matCellDef="let element; table: table">
            <button
              mat-icon-button
              aria-label="expand row"
              (click)="toggle(element); $event.stopPropagation()"
              class="requests-toggle-button"
              [class.requests-toggle-button-expanded]="isExpanded(element)"
            >
              <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="viewAdmin">
          <th mat-header-cell *matHeaderCellDef aria-label="row actions">
            Ações
          </th>
          <td mat-cell *matCellDef="let element; table: table">
            <button
              mat-icon-button
              aria-label="view row"
              (click)="goViewAdmin(element)"
              class="requests-toggle-button"
            >
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- Detalhes Expandidos -->
        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element; table: table"
            [attr.colspan]="displayedColumns.length"
          >
            <div
              class="requests-element-detail-wrapper"
              [class.requests-element-detail-wrapper-expanded]="
                isExpanded(element)
              "
            >
              <div class="requests-element-detail">
                @if (expandedDetailTemplate) {
                  <ng-container
                    *ngTemplateOutlet="
                      expandedDetailTemplate;
                      context: { $implicit: element }
                    "
                  ></ng-container>
                }
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Linhas da tabela -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="requests-element-row"
          [class.requests-expanded-row]="isExpanded(row)"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="requests-detail-row-tr"
        ></tr>
      </table>
      @if (!isLoading() && (!dataSource || dataSource().data.length === 0)) {
        <div class="no-data-message" style="text-align: center; padding: 24px">
          Nenhum dado disponível
        </div>
      }
    </div>
  </mat-card>
  <div class="paginator-row">
    <button
      mat-icon-button
      type="button"
      (click)="onRefreshClick()"
      matTooltip="Atualizar"
      [disabled]="isLoading()"
    >
      <mat-icon>refresh</mat-icon>
    </button>
    <mat-paginator
      class="paginator"
      (page)="onPageChange($event)"
      showFirstLastButtons
      [length]="length()"
      aria-label="Select page of periodic elements"
    ></mat-paginator>
  </div>
</div>
